<template>
  <bottom-sheet @close="closeMenu">
    <template v-slot:header>
      <div class="ri-large-bold-body">פעולות על המסמך
      </div>
    </template>
    <template v-slot:menuItems>
      <bottom-sheet-menu-item
        v-for="menuItem in menuItems"
        :key="menuItem.text"
        :text="menuItem.text"
        :icon-props="menuItem.iconProps"
        @click="() => onItemClick(menuItem)"
      />
    </template>
  </bottom-sheet>
</template>

<script>
import BaseUI from '@riseupil/base-ui';

export default {
  name: 'DocumentMenu',
  components: {
    BottomSheet: BaseUI.BottomSheet,
    BottomSheetMenuItem: BaseUI.BottomSheetMenuItem,
  },
  props: {
    menuItems: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  methods: {
    closeMenu() {
      this.$emit('close');
    },
    onItemClick(item) {
      this.closeMenu();
      if (item.onClick) {
        item.onClick();
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
